<template>
  <div class="copyright">
    <div class="w1200">
      <div class="copyright_t">
        <img src="../assets/images/zp_12.png">
      </div>
      <div class="copyright_b">
        <ul>
          <li><router-link :to="{path:'/'}" title="首页">首页</router-link></li>
          <li><router-link :to="{path:'/Brand'}" title="品牌中心">品牌中心</router-link></li>
          <li><router-link :to="{path:'/Faster?id=3'}" title="快速下单">快速下单</router-link></li>
          <li><router-link :to="{path:'/IndustryList'}" title="行业资讯">行业资讯</router-link></li>
          <li><router-link :to="{path:'/About'}" title="公司介绍">公司介绍</router-link></li>
        </ul>
      </div>
      <div class="copyright_c clearfix">
        <div class="copyright_cl_l">
          <div class="padd">
            <h3>关于我们</h3>
            <p><router-link :to="{path:'/About'}" style="color:#333;">公司介绍</router-link></p>
            <p><router-link :to="{path:'/Contactus'}" style="color:#333;">联系我们</router-link></p>
            <p><router-link :to="{path:'/Supplier'}" style="color:#333;">加入我们</router-link></p>
          </div>
        </div>
        <div class="copyright_cl_l">
          <div class="padd">
            <h3>帮助中心</h3>
            <p><router-link :to="{path:'/Help'}" style="color:#333;">购物指南</router-link></p>
            <p><router-link :to="{path:'/Brand'}" style="color:#333;">品牌中心</router-link></p>
            <p><router-link :to="{path:'/Sitemap'}" style="color:#333;">网站地图</router-link></p>
          </div>
        </div>
        <div class="copyright_cl_l">
          <div class="padd">
            <h3>如何付款</h3>
            <p><router-link :to="{path:'/Bill'}" style="color:#333;">付款开票信息</router-link></p>
            <p><router-link :to="{path:'/Howpay'}" style="color:#333;">如何支付</router-link></p>
          </div>
        </div>
        <div class="copyright_cl_l">
          <div class="padd">
            <h3>服务政策</h3>
            <p><router-link :to="{path:'/Shiptime'}" style="color:#333;">配送政策</router-link></p>
            <p><router-link :to="{path:'/Returngoods'}" style="color:#333;">售后服务</router-link></p>
            <p><router-link :to="{path:'/Privacy'}" style="color:#333;">隐私申明</router-link></p>
          </div>
        </div>
        <div class="copyright_cl_l">
          <div class="padd">
            <h3>内容中心</h3>
            <p><router-link :to="{path:'/IndustryList'}" style="color:#333;">行业资讯</router-link></p>
            <p><router-link :to="{path:'/Resources'}" style="color:#333;">资源社区</router-link></p>
          </div>
        </div>
        <div class="copyright_cl">
          <div class="padd">
            <p><img src="../assets/images/zp_14.png"> 400-040-7890</p>
            <p><img src="../assets/images/zp_15.png"> www.nmzp.com</p>
            <p style="line-height:20px"><img src="../assets/images/zp_16.png"> <a href="https://j.map.baidu.com/08/osZh" style="color:#333;" target="_blank">内蒙古自治区呼和浩特市赛罕区锡林南路与地质局南街交汇处未名楼A段1层1-0</a></p>
          </div>
        </div>
        <div class="copyright_cr">
          <div class="padd">
            <p>24小时全国服务热线</p>
            <span>400-040-7890</span>
            <router-link :to="{path:'/Service'}" title="在线客服">在线客服</router-link>
          </div>
        </div>
        <div class="copyright_cc">
          <img src="../assets/images/zp_17.png" style="width:134px;">
        </div>
      </div>
      <div v-if="linksList.length > 0" class="links">
        <ul>
          <li><div style="position: relative;top: -1px;">友情链接：</div></li>
          <li v-for="(item,index) in linksList.slice(0, 10)" :key="index">
            <span v-if="index > 0">|</span>
            <a target="_blank" rel="nofollow" :title="item.title" :href="item.url">{{item.title}}</a>
          </li>
          <li v-if="linksList.length > 10">
            <span>|</span>
            <a target="_blank" style="cursor:pointer;" @click="showmore()">{{ more?'收起':'更多' }}</a>
          </li>
        </ul>
      </div>
      <div v-if="more" class="links links-more" style="display: block;">
        <ul>
          <li v-for="(item,indexs) in linksList.slice(10, 20)" :key="indexs">
            <span v-if="indexs > 0">|</span>
            <a target="_blank" rel="nofollow" :title="item.title" :href="item.url">{{item.title}}</a>
          </li>
        </ul>
      </div>
      <div v-if="more && linksList.length > 20" class="links links-more" style="display: block;">
        <ul>
          <li v-for="(item,indexss) in linksList.slice(20, 30)" :key="indexss">
            <span v-if="indexss > 0">|</span>
            <a target="_blank" rel="nofollow" :title="item.title" :href="item.url">{{item.title}}</a>
          </li>
        </ul>
      </div>
      <div v-if="more && linksList.length > 30" class="links links-more" style="display: block;">
        <ul>
          <li v-for="(item,indexsss) in linksList.slice(30, 40)" :key="indexsss">
            <span v-if="indexsss > 0">|</span>
            <a target="_blank" rel="nofollow" :title="item.title" :href="item.url">{{item.title}}</a>
          </li>
        </ul>
      </div>
      <div class="copyright_bottjin">
        版权所有：志鹏供应链（内蒙古）有限公司&emsp;<a href="https://beian.miit.gov.cn" rel="nofollow" target="_blank">蒙ICP备17002862号</a>&emsp;<a target="_blank" href="https://serv.nmzp.com/uploads/1/image/20220829/9b1c29c32b1875e3ddfda561f5033689.jpg">增值电信业务经营许可证</a>&emsp;<a class="rhc_gaba" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010502001916">蒙公网安备15010502001916号</a>
      </div>
      <div class="copyright_bottjin" style="margin-top:-8px;">
        <a id="trusted_website" style="text-decoration:none;" target="_blank" href="https://xyt.xcc.cn/pcinfo?sn=1699339586947530752&certType=6"><img src="https://program.xinchacha.com/xyt/icon3.png" style="height:50px;width:137px;"></a>&emsp;
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/links'

export default {
  name: 'Footer',
  data () {
    return {
      linksList: [],
      more: false
    }
  },
  mounted () {
    this.getlinks()
  },
  methods: {
    getlinks () {
      api.getlinks().then(res => {
        this.linksList = res.items
      })
    },
    showmore () {
      if (this.more) {
        this.more = false
      } else {
        this.more = true
      }
    }
  }
}
</script>

<!-- 添加“scoped”属性来限制CSS只适用于此组件 -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue